import { render, staticRenderFns } from "./GiftOrderManage.vue?vue&type=template&id=00935d3c&"
import script from "./GiftOrderManage.vue?vue&type=script&lang=js&"
export * from "./GiftOrderManage.vue?vue&type=script&lang=js&"
import style0 from "./GiftOrderManage.vue?vue&type=style&index=0&id=00935d3c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00935d3c')) {
      api.createRecord('00935d3c', component.options)
    } else {
      api.reload('00935d3c', component.options)
    }
    module.hot.accept("./GiftOrderManage.vue?vue&type=template&id=00935d3c&", function () {
      api.rerender('00935d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/points/gift-order-manage/GiftOrderManage.vue"
export default component.exports